import { render, staticRenderFns } from "./GameBuilderFrameStep.vue?vue&type=template&id=72d41ed7&scoped=true&"
import script from "./GameBuilderFrameStep.vue?vue&type=script&lang=js&"
export * from "./GameBuilderFrameStep.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderFrameStep.vue?vue&type=style&index=0&id=72d41ed7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d41ed7",
  null
  
)

export default component.exports